import * as React from 'react'
import { FC, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { useCheckPermissions } from '@user/store/authorization/permissions/useCheckPermissions'

const styles = {
  indicator: {
    backgroundColor: '#005AA3',
  },

  selectedTab: {
    color: '#005AA3',
  },
}

export const EntityTypeTabs: FC = () => {
  const [value, setValue] = React.useState(0)
  const location = useLocation()
  const navigate = useNavigate()

  const [canViewPendingLeads, canViewOpportunities, canViewLeads] =
    useCheckPermissions(
      'pending_leads_view',
      'opportunities_view',
      'leads_view',
    )

  const handleChange = React.useCallback(
    (_event, newValue: number) => {
      setValue(newValue)

      switch (newValue) {
        case 0:
          navigate('/leads')
          break
        case 1:
          navigate('/pending-leads')
          break
        case 2:
          navigate('/opportunities')
          break
        default:
          return
      }
    },
    [navigate],
  )

  useEffect(() => {
    switch (location.pathname) {
      case '/leads':
        setValue(0)
        break
      case '/pending-leads':
        setValue(1)
        break
      case '/opportunities':
        setValue(2)
        break
      default:
        return
    }
  }, [location])

  return (
    <Tabs
      sx={{ indicator: styles.indicator }}
      onChange={handleChange}
      value={value}
      style={{ marginRight: 'auto' }}
    >
      {canViewPendingLeads && (
        <Tab
          sx={{ selected: styles.selectedTab }}
          label="Pending Leads"
          value={1}
          data-test-id="pending-leads-tab"
        />
      )}
      {canViewLeads && (
        <Tab
          sx={{ selected: styles.selectedTab }}
          label="Leads"
          value={0}
          data-test-id="leads-tab"
        />
      )}
      {canViewOpportunities && (
        <Tab
          sx={{ selected: styles.selectedTab }}
          label="Opportunities"
          value={2}
          data-test-id="opportunities-tab"
        />
      )}
    </Tabs>
  )
}
